import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaEquiposAdquiridos from "./Equipos/CreaModals/CreaEquiposAdquiridos";
import Cookies from "universal-cookie";

function Titulo24SeccionC(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const obtenerEquipos = async () => {
    try {
      const res = await axios({
        method: "get",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url:
          "https://suadesarrollo.azurewebsites.net/api/ObtenerEquiposAdquiridosPorSolicitudId?SolicitudId=" +
          props.idSolicitud,
      });

      setList(res.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    obtenerEquipos();
  }, [props.idSolicitud]);

  // 🔥 ACTUALIZACIÓN INMEDIATA
  const agregarEquipos = (data) => {
    if (Array.isArray(data)) {
      setList((prev) => [...data, ...prev]);
    } else {
      obtenerEquipos(); // fallback si no devuelve registros
    }
    setCurrentPage(1); // vuelve a la primera página
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = list.slice(indexOfFirstItem, indexOfLastItem);

  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1];

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="font-weight-bold text-primary">
            2.4.1 Equipos adquiridos riesgo medio y alto (últimos 2 años)
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
          window.location.href.includes("ProcesoAutoevaluacion") ? (
            <CreaEquiposAdquiridos
              idSolicitud={props.idSolicitud}
              onCreate={agregarEquipos}
            />
          ) : null}

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nombre</th>
                  <th>Marca</th>
                  <th>Modelo</th>
                  <th>Fecha Adquisición</th>
                  <th>Garantía</th>
                  <th>Años Vida Útil</th>
                  <th>Tipo Riesgo</th>
                  <th>Clasificación Biomédica</th>
                  <th>Periodicidad</th>
                  <th>Fecha Mantenimiento</th>
                  <th># Mantenimientos</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length === 0 ? (
                  <tr>
                    <td colSpan="12" className="text-center">
                      No hay registros
                    </td>
                  </tr>
                ) : (
                  currentItems.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.nombre}</td>
                      <td>{item.marca}</td>
                      <td>{item.modelo}</td>
                      <td>{item.fecha_Adquisiscion}</td>
                      <td>{item.garantia}</td>
                      <td>{item.anos_vida_util}</td>
                      <td>{item.tipo_riesgo}</td>
                      <td>{item.clasificacion_biomedica}</td>
                      <td>{item.periodicidad}</td>
                      <td>{item.fecha_mantenimiento}</td>
                      <td>{item.numero_Mantenimientos}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-between mt-3">
            <button
              className="btn btn-secondary"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              Anterior
            </button>

            <span>
              Página {currentPage} de{" "}
              {Math.max(1, Math.ceil(list.length / itemsPerPage))}
            </span>

            <button
              className="btn btn-secondary"
              disabled={currentPage === Math.ceil(list.length / itemsPerPage)}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Siguiente
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Titulo24SeccionC;
